import { createSelector } from 'reselect';
import { getAfyaImaraState } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';

export const getPersonalDetails = createSelector(getAfyaImaraState, (state) => state.personalDetails);

export const getPersonalDetailsForm = createSelector(getPersonalDetails, (personalDetails) => personalDetails.form);

export const getSelectedForm = createSelector(getPersonalDetails, (personalDetails) => personalDetails.selectedForm);

export const getPersonalDetailsFormValid = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.formStatus === FORM_STATUS.VALID
);

export const getPersonalDetailsId = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.personalDetailId
);

export const getIsApiPending = createSelector(
    getPersonalDetails,
    (personalDetails) => personalDetails.apiCallStatus === API_CALL_STATUS.PENDING
);

export const getApiCallStatus = createSelector(getPersonalDetails, (personalDetails) => personalDetails.apiCallStatus);

const makeGetFieldForm = (fieldId) => createSelector(getPersonalDetailsForm, (form) => form[fieldId]);

export const getFirstNameValue = makeGetFieldForm('firstName');
export const getGenderValue = makeGetFieldForm('gender');
export const getMaritalStatusValue = makeGetFieldForm('maritalStatus');
export const getNihfNumberValue = makeGetFieldForm('nihfNumber');
export const getLastNameValue = makeGetFieldForm('lastName');
export const getDOBValue = makeGetFieldForm('dob');
export const getPhoneNumberValue = makeGetFieldForm('phoneNumber');
export const getIdNumberValue = makeGetFieldForm('idNumber');
export const getTinNumberValue = makeGetFieldForm('tinNumber');
export const getStreetAddressValue = makeGetFieldForm('streetAddress');
export const getSuburbValue = makeGetFieldForm('suburb');
export const getCityValue = makeGetFieldForm('city');
export const getEmailValue = makeGetFieldForm('email');
export const getPostalAddressValue = makeGetFieldForm('postalAddress');
export const getReferredValue = makeGetFieldForm('referred');
